import { Controller } from "@hotwired/stimulus";
import { shouldActivateClickEvent } from "../../../utils/keyboardAccessibility";
import { waitForRailsuiModalController } from "../../../utils/railsui_modal";
import {
  announceTodoModalLoaded,
  announceTodoModalLoadError,
  announceTodoModalLoading,
  centerTodoModalOverlayScroll,
  turboStreamTodoFormUrl,
} from "../../../utils/quiz_results_todo_modal";

const ADD_MANAGE_TODO_MODAL_ID = "quiz-results-add-manage-todo-modal";

export default class extends Controller {
  openTodoModal(event) {
    if (!this.shouldActivateTodoModal(event)) return;

    event.preventDefault();
    event.stopPropagation();

    const trigger = event.currentTarget;
    if (trigger.dataset.preloaded === "true") {
      this.showTodoModal(trigger);
      return;
    }

    const url = turboStreamTodoFormUrl(trigger.dataset.url);
    if (!url) return;

    announceTodoModalLoading();

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          announceTodoModalLoadError();
          return null;
        }

        return response.text();
      })
      .then((html) => {
        if (html == null) return;

        announceTodoModalLoaded();
        return Promise.resolve(Turbo.renderStreamMessage(html)).then(() => {
          return this.showTodoModal(trigger);
        });
      })
      .catch(() => {
        announceTodoModalLoadError();
      });
  }

  async showTodoModal(trigger) {
    const modalRoot = document.getElementById(ADD_MANAGE_TODO_MODAL_ID);
    const railsui = await waitForRailsuiModalController(modalRoot);
    if (!railsui) return;

    railsui.show({
      preventDefault() {},
      currentTarget: trigger,
    });
    requestAnimationFrame(() => {
      centerTodoModalOverlayScroll(ADD_MANAGE_TODO_MODAL_ID);
    });
  }

  shouldActivateTodoModal(event) {
    if (!shouldActivateClickEvent(event)) return false;

    if (event.type === "keydown" && event.currentTarget?.tagName === "A") {
      event.preventDefault?.();
    }

    return true;
  }
}
